import { useState, useEffect } from 'react';

import { getFromStore, setToStore } from '../store';

const storeKey = 'compliance-cookiebanner-optin';

export default function useOptIn(levels = ['analytics']) {
  const [optIn, setOptIn] = useState(getFromStore(storeKey, {}));

  useEffect(() => {
    setToStore(storeKey, optIn);
  }, [optIn]);

  const onOptInAll = () => {
    setOptIn(Object.fromEntries(levels.map(level => [level, new Date()])));
  };

  const onOptIn = level => {
    setOptIn({
      ...optIn,
      [level]: new Date(),
    });
  };

  const onOptOut = level => {
    const newOptIn = { ...optIn };
    delete newOptIn[level];
    setOptIn(newOptIn);
  };

  return [optIn, onOptInAll, onOptIn, onOptOut];
}
